import * as React from 'react'


export const Image = ({ src, alt }) => {
    return (
        <div className="c-image-block">
            <img src={src} alt={alt} />
        </div>
    )
}
